<template>
  <div class="ce-view">
    <div
      v-if="isInitializing"
      class="loading"
    >
      <unc-loader />
    </div>

    <template v-else-if="showNotFound">
      <div class="register-card ce-card rr-notfound-card">
        <div class="rr-notfound-inner">
          <div class="rr-notfound-icon">
            <svg
              aria-hidden="true"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              />
              <line
                x1="12"
                y1="8"
                x2="12"
                y2="12"
              />
              <line
                x1="12"
                y1="16"
                x2="12.01"
                y2="16"
              />
            </svg>
          </div>
          <h1 class="rr-notfound-title">
            No se pudo confirmar tu correo
          </h1>
          <p class="rr-notfound-desc">
            El enlace utilizado caducó o no es válido. Iniciá nuevamente el proceso de
            creación de Usuario UNC para que volvamos a enviarte el correo.
          </p>

          <div class="rr-actions rr-actions--center">
            <button
              type="button"
              class="btn btn-primary waves-effect register-btn register-btn-primary rr-notfound-btn"
              @click.prevent="goRegister()"
            >
              <span>Ir a crear Usuario UNC</span>
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="ce-flow">
        <div class="register-card ce-card ce-card--step ce-card--next">
          <div class="card-header ch-alt register-header ce-step-header">
            <div class="ce-step-headline">
              <div class="register-kicker rr-kicker--info">
                Siguiente acción
              </div>
            </div>
            <h1 class="ce-step-title register-title">
              Necesitamos verificar tus datos personales
            </h1>
            <p class="register-subtitle">
              Contactá al administrador de tu dependencia o facultad por correo.
            </p>
          </div>

          <div class="card-body register-body">
            <div class="ce-instructions">
              <p class="ce-instructions-lead">
                Enviá un correo al <a
                  href="/contactos"
                  target="_blank"
                  class="register-text-link"
                  rel="noopener"
                >administrador de tu
                  dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a> incluyendo la siguiente información:
              </p>

              <div class="ce-instr-block">
                <div class="ce-instr-label">
                  Asunto
                </div>
                <ul class="ce-instr-list">
                  <li>Verificación de datos personales y relación con la UNC.</li>
                </ul>
              </div>

              <div class="ce-instr-block">
                <div class="ce-instr-label">
                  Mensaje
                </div>
                <ul class="ce-instr-list">
                  <li>Nombre y apellido.</li>
                  <li>Número y constancia de CUIL.</li>
                </ul>
              </div>

              <div class="ce-instr-block">
                <div class="ce-instr-label">
                  Consideraciones según tu rol
                </div>
                <ul class="ce-instr-list">
                  <li>
                    Si tu rol es <strong>Estudiante/Egresado</strong>, debés contactar a la facultad en la que tenés
                    usuario en Guaraní.
                  </li>
                  <li>
                    Si tu rol es <strong>Docente/Nodocente/Contratado</strong>, debés adjuntar documentación que avale
                    la relación con la UNC (por ejemplo: Resolución).
                  </li>
                  <li>
                    Si tu rol es <strong>Otro</strong>, comentá una breve descripción del porqué solicitás la creación
                    del Usuario UNC.
                  </li>
                </ul>
              </div>

              <p class="ce-instructions-footer">
                Cuando tus datos se encuentren verificados recibirás un mail para elegir tu nombre de Usuario UNC.
              </p>
            </div>

            <div class="rr-actions rr-actions--center ce-contact-cta">
              <router-link
                to="/contactos"
                class="btn btn-primary waves-effect register-btn register-btn-primary"
              >
                <span>Ver listado de administradores</span>
                <svg
                  aria-hidden="true"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { HttpFRONT, swal } from '../../share.js';

export default {
    name: 'ConfirmEmail',
    props: {
        token: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            titulo: 'CONFIRMAR EMAIL',
            isInitializing: true,
            user: '',
            showNotFound: false,
        };
    },
    computed: {
        showOneColumn () {
            return window.screen.width < 400;
        },
    },
    async mounted () {
        if (this.token) {
            await this.getData();
        } else {
            this.showNotFound = true;
            this.isInitializing = false;
        }
    },
    methods: {
        async getData () {
            try {
                const response = await HttpFRONT.get(`confirmemail/${this.token}`);
                this.isInitializing = false;
                if (response.status === 200) {
                    this.showNotFound = false;
                    swal({
                        title: '¡Tu correo fue verificado correctamente!',
                        text: 'Leé atentamente las siguientes instrucciones para continuar con el proceso de creación de tu Usuario UNC. ',
                        type: 'success',
                    });
                } else {
                    this.showNotFound = true;
                }
            } catch (error) {
                const status = error.response?.status ?? 500;
                const message = error.response?.data || 'Servicio temporalmente no disponible';
                this.isInitializing = false;

                switch (status) {
                case 404:
                    this.showNotFound = true;
                    break;
                case 409:
                    swal({ title: 'Algo salió mal', text: 'El período de confirmación de este correo caducó.', type: 'warning' });
                    this.$router.push('/');
                    break;
                case 500:
                    swal({ title: 'Algo salió mal', text: message, type: 'warning' });
                    this.$router.push('/');
                    break;
                default:
                    await swal({ title: 'Algo salió mal', text: message, type: 'warning' });
                    this.$router.push('/');
                    break;
                }
            }
        },
        goRegister () {
            this.$router.push('/registro');
        },
    },
};
</script>

<style lang="scss" scoped>
@import './register-shared.scss';

.ce-view {
  --register-azul: #003865;
  --register-azul-deep: #001f3f;
  --register-azul-mid: #0a5f96;
  --register-verde: #3eb6b8;
  --register-ink: #102238;
  --register-muted: #526579;
  --register-border: rgba(0, 56, 101, 0.14);

  font-family: var(--font-body);
  min-height: 60vh;
  padding: 32px 16px 40px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.ce-card {
  width: 100%;
  max-width: $register-card-wide;
}

.ce-card--success {
  max-width: $register-card-wide;
}

.ce-flow {
  width: 100%;
  max-width: $register-card-wide;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ce-card--step {
  max-width: $register-card-wide;
}

.ce-card--confirmed {
  border: 1px solid rgba(29, 158, 126, 0.18);
  box-shadow: 0 18px 44px rgba(11, 38, 64, 0.12);
}

.ce-card--next {
  border: 1px solid rgba(0, 56, 101, 0.14);
}

.ce-flow-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--register-azul-mid);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  font-weight: 700;
}

.ce-flow-divider::before,
.ce-flow-divider::after {
  content: '';
  height: 1px;
  flex: 1;
  max-width: 180px;
  background: linear-gradient(90deg, transparent, rgba(0, 56, 101, 0.32), transparent);
}

.ce-step-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ce-step-headline {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ce-step-headline .register-kicker {
  margin-bottom: 0;
}

.ce-step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.ce-step-badge--done {
  color: #177a62;
  background: rgba(29, 158, 126, 0.14);
  border: 1px solid rgba(29, 158, 126, 0.24);
}

.ce-step-badge--current {
  color: var(--register-azul-mid);
  background: rgba(10, 95, 150, 0.09);
  border: 1px solid rgba(10, 95, 150, 0.25);
}

.ce-step-title {
  margin: 0;
}

.ce-success-strip {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(29, 158, 126, 0.08);
  border: 1px solid rgba(29, 158, 126, 0.2);
  border-radius: 12px;
  padding: 14px 16px;
}

.ce-success-icon {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: rgba(29, 158, 126, 0.16);
  color: #15765f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  flex-shrink: 0;
}

.ce-success-text {
  margin: 0;
  color: var(--register-ink);
  line-height: 1.55;
  font-size: 14px;
}

.ce-view .rr-kicker--success {
  border: 1px solid rgba(29, 158, 126, 0.24);
  background: rgba(29, 158, 126, 0.1);
  color: #1d9e7e;
}

.ce-view .rr-kicker--danger {
  border: 1px solid rgba(192, 57, 43, 0.24);
  background: rgba(220, 53, 69, 0.1);
  color: #c0392b;
}

.ce-view .rr-kicker--warning {
  border: 1px solid rgba(183, 119, 13, 0.24);
  background: rgba(243, 156, 18, 0.12);
  color: #b7770d;
}

.ce-view .rr-kicker--info {
  border: 1px solid rgba(10, 95, 150, 0.2);
  background: rgba(10, 95, 150, 0.08);
  color: var(--register-azul-mid);
}

.ce-status-block {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 14px;
  margin-bottom: 20px;
}

.ce-status-block--danger {
  background: rgba(220, 53, 69, 0.07);
  border: 1px solid rgba(220, 53, 69, 0.18);
  color: #c0392b;
}

.ce-status-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.ce-status-msg {
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 4px;
}

.ce-status-sub {
  font-size: 13px;
  margin: 0;
  opacity: 0.85;
}

.ce-instructions {
  margin-bottom: 20px;
}

.ce-instructions-lead {
  font-size: 15px;
  color: var(--register-ink);
  margin: 0 0 16px;
  line-height: 1.65;
}

.ce-instr-block {
  margin-bottom: 14px;
}

.ce-instr-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--register-azul-mid);
  margin-bottom: 8px;
}

.ce-instr-list {
  margin: 0;
  padding-left: 22px;
  color: var(--register-ink);
}

.ce-instr-list li {
  font-size: 15px;
  line-height: 1.65;
  margin-bottom: 6px;
}

.ce-instructions-footer {
  font-size: 14px;
  color: var(--register-muted);
  margin: 20px 0 0;
  padding: 14px 18px;
  background: rgba(0, 56, 101, 0.04);
  border-radius: 10px;
  border-left: 3px solid var(--register-verde);
  line-height: 1.5;
}

.ce-contact-cta {
  margin-top: 4px;
}

@media (max-width: 600px) {
  .ce-view {
    padding: 24px 12px 32px;
  }

  .ce-flow {
    gap: 14px;
  }

  .ce-flow-divider::before,
  .ce-flow-divider::after {
    max-width: 80px;
  }

  .ce-step-headline {
    gap: 8px;
  }

  .ce-success-strip {
    padding: 12px 12px;
  }

  .ce-instructions-lead {
    font-size: 14px;
  }

  .ce-instr-list li {
    font-size: 14px;
  }

  .ce-instructions-footer {
    font-size: 14px;
  }
}
</style>
